<div>
        <FlashMessage></FlashMessage>
    <div class="white-box">
        <div class="table-wrap">
            <div class="sort-wrapper ">
                <div class="table-title pl-0 pb-0">
                    <h5>Manage account</h5>
                </div>
                <hr>
                <div class="row">
                    <div class="col-lg-6" @click.prevent="toggleFilter">
                        <p class="blue-color"><i class="fas fa-filter"></i> Filter</p>
                    </div>
                    <div class="col-lg-6">
                        <div class="clear text-right"><a><i class="fas fa-redo"></i> clear all filters
                            </a></div>
                    </div>
                </div>
                <form action="">
                    <div class="collapse filter-body">
                        <div class="error-list" v-if="errorsMessage">
                            <ul class="error-msg">
                                <li v-for="(error,x) in errorsMessage" :key="x">
                                    <div v-for="(err,i) in error" :key="i">
                                        <p> {{err}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Company name</label>
                                    <input type="text" placeholder="Company name" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Website</label>
                                    <input type="text" placeholder="Company name" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Phone number</label>
                                    <input type="text" placeholder="Company name" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="empty-data" v-if="!RequestList.length">
                <p v-if="!RequestList.length" class="mb-0">
                    No Account List
                </p>
            </div>
            <div class="table-responsive mt-3" v-if="RequestList.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="w-40">Company info</th>

                            <th scope="col" class="w-20">Requested Services</th>
                            <th scope="col" class="w-20">Allocated Services</th>
                            <th scope="col" class="w-20">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(request, index) in RequestList" :key="index">
                            <td class="w-30">
                                <div class="block-list manage-acc">
                                    <ul class="pl-0">
                                        <!-- <p>{{request}}</p> -->
                                        <li class="clearfix" v-if="request.company_name"><span class="label">Company
                                                Name</span>
                                            <span>{{request.company_name}}</span></li>
                                        <li class="clearfix" v-if="request.company_country"><span
                                                class="label">Country</span>
                                            <span>{{request.company_country}}</span></li>
                                        <li class="clearfix" v-if="request.company_email"><span
                                                class="label">Email</span>
                                            <span>{{request.company_email}}</span></li>
                                        <li class="clearfix"><span class="label" v-if="request.address">Address</span>
                                            <span>{{request.address}}</span></li>
                                        <li class="clearfix" v-if="request.contact_number"><span class="label">Contact
                                                number</span> <span>{{request.contact_number}}</span></li>
                                        <!-- <li class="clearfix"><span class="label" v-if="request.phone2">Phone number</span> <span>{{request.phone2}}</span></li> -->
                                        <li class="clearfix" v-if="request.mobile1 || request.mobile2"><span
                                                class="label">Mobile number</span> <span>{{request.mobile1}},
                                                {{request.mobile2}}</span></li>
                                        <li class="clearfix" v-if="request.comments"><span class="label">Comment</span>
                                            <span class="text-box">{{request.comments}}</span></li>

                                    </ul>
                                </div>
                            </td>

                            <td class="w-20">
                                <!-- <p>{{request.SelectAll}}</p> -->
                                <div class="services-type">
                                    <ul class="pl-0">
                                        <li v-for="(type, type_index) in request.account_modules" :key="type_index"><i
                                                class="fas fa-caret-right"></i>
                                            <div v-if="type.system_module">{{type.system_module.name}}</div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td class="w-20">
                                <!-- <p>{{request.SelectAll}}</p>
                                    <label class="customcheck">Select all
                                        <input type="checkbox" name="" value="" class="destination" data-toggle="modal"
                                            v-model="request.SelectAll" data-target="#exampleModal"
                                            @change="check(request)">
                                        <span class="checkmark"></span>
                                    </label>
                                    <input type="checkbox" name="" value="" class="destination" data-toggle="modal" <label
                                        class="customcheck" v-for="(type, type_index) in request.account_modules"
                                        :key="type_index">{{type.code}}
                                    <input type="checkbox" name="" value="" class="destination" data-toggle="modal"
                                        data-target="#exampleModal" v-model="type.service" @change="checkType(type)">
                                    <span class="checkmark"></span>
                                    </label> -->
                                <div class="services-type">
                                    <ul class="pl-0">
                                        <li v-if="request.account_modules"
                                            v-for="(type, type_index) in request.account_modules" :key="type_index"><i
                                                class="fas fa-caret-right"></i>
                                            <div v-if="type.system_module">{{type.system_module.name}}</div>
                                            <div v-if="request.account_modules.length === type_index+1">
                                                <p v-if="request.note">{{request.note}}</p>
                                                <p v-if="request.note_date">{{request.note_date}}</p>
                                                <p v-if="request.note_by">{{request.note_by.full_name}}</p>
                                            </div>
                                            <a v-if="request.account_modules.length === type_index +1" href="#"
                                                class="btn default-btn" data-toggle="modal" 
                                                
                                                @click.prevent="grandService(type, index)">Assign/Unassign</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td class="w-30">
                                <div>
                                    <button class="btn default-btn green position-relative" data-toggle="collapse"
                                        data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo"
                                        :disabled="Status.ShowTextEnable" @click.prevent="showEnableModal">Enable</button>
                                    <button class="btn default-btn red position-relative" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                        :disabled="Status.ShowTextDisable">Disable
                                    </button>
                                </div>
                                <button class="btn default-btn blue" v-if="request.is_approved === 0"
                                    @click.prevent="verifyAccountRequest(request, index)"
                                    :disabled="Status.DisableVerify">Verify</button>

                                <div v-if="request.account">
                                    <div v-if="request.account.status === 0">
                                        <p>{{request.account.disabled_comments}}</p>
                                    </div>
                                    <div v-if="request.account.status === 1">
                                        <p>{{request.account.enabled_comments}}</p>
                                    </div>
                                </div>
                                <div v-if="request.account">
                                    <div v-if="Status.ShowDisableModal" class="collapse dialog-wrap"
                                        aria-labelledby="headingOne" data-parent="#accordionExample">
                                        <div class="dialog-body">

                                            <div class="form-wrap">
                                                <div class="form-group">
                                                    <label for="">Are you sure you want to disable? </label>
                                                    <textarea name="" id="" cols="" rows="" class="form-control"
                                                        v-model="Comment.Disable"></textarea>
                                                </div>
                                            </div>
                                            <button class="btn default-btn save-btn btn-sm"
                                                @click.prevent="disable(request, index)"
                                                :disabled="Status.ShowTextDisable">Save</button>
                                            <button class="btn default-btn cancel btn-sm"
                                                @click.prevent="cancelDisable">Cancel</button>
                                        </div>
                                    </div>
                                    <div v-if="Status.ShowEnableModal" class="collapse dialog-wrap"
                                        aria-labelledby="headingTwo" data-parent="#accordionExample">
                                        <div class="dialog-body">

                                            <div class="form-wrap">
                                                <div class="form-group">
                                                    <label for="">Are you sure you want to Enable? </label>
                                                    <textarea name="" id="" cols="" rows="" class="form-control"
                                                        v-model="Comment.Enable"></textarea>

                                                </div>
                                            </div>
                                            <button class="btn default-btn save-btn btn-sm"
                                                @click.prevent="enable(request, index)"
                                                :disabled="Status.ShowTextEnable">Save</button>
                                            <button class="btn default-btn cancel btn-sm"
                                                @click.prevent="cancelEnable">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- <div class="pagination-block justify-content-center">
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item page-item disabled"><a aria-label="Previous" class="page-link" href=""><span
                    aria-hidden="true"><i class="fas fa-angle-left"></i></span> <span
                    class="sr-only">Previous</span></a></li>
              <li class="page-item active"><a class="page-link" href=""><span class="page-item active">1</span></a>
              </li>
              <li class="page-item"><a class="page-link" href=""><span class="page-item">2</span></a></li>
              <li class="page-item"><a aria-label="Next" class="page-link" href=""><span aria-hidden="true"><i
                      class="fas fa-angle-right"></i></span> <span class="sr-only">Next</span></a></li>
            </ul>
          </nav>
        </div> -->

    <!-- Modal -->
    <div class="modal-wrap">
        <div class="modal fade" id="services" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Assign services</h5>
                        <button type="button" class="close" aria-label="Close" @click.prevent="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="mb-4">Check services you would like to assign to the company.</p>
                        <div class="error-list" v-if="errorsModal">
                                <ul class="error-msg">
                                  <li v-for="(error,x) in errorsModal" :key="x">
                                    <div v-for="(err,i) in error" :key="i">
                                      <p> {{err}}</p>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                        <label class="customcheck" v-for="(service, service_index) in ServiceList"
                            :key="service_index">{{service.name}}
                            <input type="checkbox" name="" value="" class="destination" v-model="service.SelectAll"
                                @change="checkType(service)">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="modal-body">
                        <label for="">Notes</label>
                        <textarea name="" id="" cols="" rows="" class="form-control" v-model="Note"></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn default-btn" data-dismiss="modal"
                            @click.prevent="grantServiceToAccount">Save</button>
                        <button type="button" class="btn default-btn cancel" @click.prevent="closeModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Pager @onPaging="onPaging" :pager="paging"></Pager>
</div>


</div>